import React, { Fragment, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Typography, Box, CircularProgress } from '@material-ui/core';
import { useStyles } from './styles';
import { colors } from '../../../theme/color-palette';
import { Drawer } from '../../../common';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { UserPortalContext } from '../../../context/appcontext';
import { useDispatch, useSelector } from 'react-redux';
import { getSubRuleNotification } from '../../../redux/actions/createRuleActions';

const Accordion = ({
	title,
	description,
	createdDate,
	hasSubAlerts,
	parentId,
}) => {
	const classes = useStyles();
	const [isActive, setIsActive] = useState(false);
	const portalUserContext = useContext(UserPortalContext);
	const dispatch = useDispatch();
	const formattedDate = createdDate?.substr(5, 5)?.replace('-', '/');

	const { subRuleNotifications, subRuleNotificationLoading } = useSelector(
		(state) => state.createRuleReducer
	);

	const [subRuleNofication, setSubRuleNotification] = useState(false);

	const openSubRuleNotification = () => {
		setSubRuleNotification(true);
		dispatch(getSubRuleNotification({ portalUserContext, parentId }));
	};

	const closeSubRuleNotification = () => {
		setSubRuleNotification(false);
	};

	function getSubRuleNotificationComponent(subRuleNotifications) {
		if (subRuleNotifications?.length > 0) {
			return subRuleNotifications?.map((item, id) => (
				<Box key={`sub-rule-notification-${id}`} className={classes.accordion}>
					<Box className={classes.accordionItem}>
						<TrendingUpIcon
							sx={{
								transform: `rotateZ(180deg)`,
								color: colors.PURPLE,
							}}
						/>
						<Typography className={classes.itemTitle}>
							{item.message}
						</Typography>
					</Box>
				</Box>
			));
		} else {
			return <></>;
		}
	}
	return (
		<Box
			className={classes.accordion}
			style={{ paddingBottom: isActive ? '10px' : 0 }}>
			<Box className={classes.accordionItem}>
				<TrendingUpIcon
					sx={{ transform: `rotateZ(180deg)`, color: colors.PURPLE }}
				/>
				<Typography
					className={classes.itemTitle}
					onClick={() => setIsActive(!isActive)}>
					{title}
				</Typography>
				<Typography className={classes.itemDate}>{formattedDate}</Typography>
			</Box>
			{isActive && <div className={classes.itemDescription}>{description}</div>}
			{isActive && hasSubAlerts && (
				<Box
					component="span"
					onClick={openSubRuleNotification}
					sx={{
						pd: 10,
						m: 2,
						width: 400,
						textDecoration: 'underline',
						fontSize: '14px',
						cursor: 'pointer',
					}}>
					View details
				</Box>
			)}
			<Fragment>
				<Drawer open={subRuleNofication} width={360}>
					<Box className={classes.container}>
						{/* Header */}
						<Box className={classes.header}>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<ArrowBackIosNewIcon
									className={classes.backBtn}
									onClick={closeSubRuleNotification}
								/>
								<Box className={classes.headerText}>{title}</Box>
							</Box>
						</Box>
						{/* Content */}
						<Box className={classes.content}>
							<Box className={classes.itemDescription}>{description}</Box>
							{subRuleNotificationLoading ? (
								<Box className={classes.loaderContainer}>
									<CircularProgress className={classes.circularProgress} />
								</Box>
							) : (
								getSubRuleNotificationComponent(subRuleNotifications)
							)}
						</Box>
					</Box>
				</Drawer>
			</Fragment>
		</Box>
	);
};

Accordion.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	createdDate: PropTypes.string,
	hasSubAlerts: PropTypes.bool,
	parentId: PropTypes.string,
};

export default Accordion;
